import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import service from './service'

export const getTransactionStatusAndOrderStatusThunk = createAsyncThunk(
  'userManagement/subscriptionPayment/orderManagement/getTransactionStatusAndOrderStatusThunk',
  async (params, { rejectWithValue }) => {
    try {
      const [transactionStatus, orderStatus] = await Promise.all([
        service.getTransactionStatus(params),
        service.getOrderStatus(params),
      ])

      if (!transactionStatus.success || !orderStatus.success) {
        return rejectWithValue({ isLoading: false })
      }

      return {
        transactionStatus: transactionStatus.data,
        orderStatus: orderStatus.data,
      }
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getListOrdersThunk = createAsyncThunk(
  'userManagement/subscriptionPayment/orderManagement/getListOrdersThunk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await service.getListOrders(params)

      return res.success ? res : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const postNewTransactionOrders = createAsyncThunk(
  'userManagement/subscriptionPayment/orderManagement/postNewTransactionOrders',
  async (params) => {
    const response = await service.postNewTransactionOrders(params)
    return response
  },
)
